/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */
import {
  annebell,
  avatr2,
  bahubali,
  bean1,
  elon,
  Mark,
  bean2,
  catchME,
  conjuring,
  hobbit,
  lunchBox,
  mercy,
  minion2,
  tom,
  orlando,
  whoRU,
  motive1,
  motive2,
  shtFilm,
  shtFilm1
} from "../../assests/images/thumnail";
export const videos = [
  {
    _id: "Wo5dMEP_BbI",
    title: "The future we're building",
    thumbNail: elon,
    videoSpan: "40:50",
    subtitle: "Elon Musk",
    views: "366K",
    publishedYear: "2 years ago",
    categoryName: "Motivational",
    videoLink: "zIwLWfaAg-8",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    creator: "Soham Shah"
  },
  {
    _id: "F_Riqjdh2oM",
    title: "Introducing Meta",
    creator: "Sentdex",
    thumbNail: Mark,
    videoSpan: "06:46",
    subtitle: "Mark Zukerberg",
    views: "1.3M",
    publishedYear: "6months ago",
    categoryName: "Motivational",
    videoLink: "pjNI9K1D_xo",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga."
  },
  {
    _id: "Wo5dMEP_BbI1",
    thumbNail: catchME,
    title: "Catch Me If You Can",
    videoSpan: "04:36",
    subtitle: "a film",
    views: "486K",
    publishedYear: "2 years ago",
    categoryName: "Movie Trailers",
    videoLink: "lN6Irv9tnYI",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    creator: "unknown"
  },
  {
    _id: "Wo5dMEP_BbI2",
    thumbNail: annebell,
    title: "ANNABELLE horror ",
    videoSpan: "04:56",
    subtitle: "ANNABELLE trailer",
    views: "23M",
    publishedYear: "3 years ago",
    categoryName: "Movie Trailers",
    videoLink: "bCxm7cTpBAs",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    creator: "unknown"
  },
  {
    _id: "Wo5dMEP_BbI3",
    thumbNail: avatr2,
    title: "Avatar exclusive trailer",
    videoSpan: "05:12",
    subtitle: "JamesCameroon",
    views: "20M",
    publishedYear: "5 years ago",
    categoryName: "Movie Trailers",
    videoLink: "MknKGdvuYKo",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    creator: "unknown"
  },
  {
    _id: "Wo5dMEP_BbI4",
    thumbNail: conjuring,
    title: "The Conjuring 2 ",
    videoSpan: "04:16",
    subtitle: "Valak Painting",
    views: "4.1M ",
    publishedYear: "5 years ago",
    categoryName: "Movie Trailers",
    videoLink: "ZDZpXRDS5vU",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    creator: "unknown"
  },
  {
    _id: "Wo5dMEP_BbI5",
    thumbNail: hobbit,
    title: "Hobbit",
    videoSpan: "07:12",
    subtitle: "warner Bros.Pictures",
    views: "7.1M",
    publishedYear: "9years ago",
    categoryName: "Movie Trailers",
    videoLink: "SDnYMbYB-nU",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    creator: "unknown"
  },
  {
    _id: "Wo5dMEP_BbI6",
    thumbNail: mercy,
    title: "JUST MERCY Trailer",
    videoSpan: "03:58",
    subtitle: "Warner Bros.Pictures",
    views: "11M",
    publishedYear: "2 years ago",
    categoryName: "Movie Trailers",
    videoLink: "GVQbeG5yW78",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    creator: "unknown"
  },
  {
    _id: "Wo5dMEP_BbI7",
    thumbNail: bahubali,
    title: "Bahubali 2",
    videoSpan: "05:10",
    subtitle: "Dharma Production",
    views: "123M",
    publishedYear: "5 years ago",
    categoryName: "Movie Trailers",
    videoLink: "G62HrubdD6o",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    creator: "unknown"
  },
  {
    _id: "Wo5dMEP_BbI8",
    thumbNail: bean1,
    title: "MR BEAN",
    videoSpan: "45:10",
    subtitle: "Shopping for NEW YEAR!",
    views: "142K",
    publishedYear: "2 years ago",
    categoryName: "Animation",
    videoLink: "tI1jF98hlmM",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    creator: "cartoon world"
  },
  {
    _id: "Wo5dMEP_BbI9",
    thumbNail: lunchBox,
    title: " Nidhis Lunch Box",
    videoSpan: "14:56",
    subtitle: "Six Sigma Films",
    views: "59K",
    publishedYear: "3 months ago",
    categoryName: "Short film",
    videoLink: "tQJODgPVjIk",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    creator: "unknown"
  },
  {
    _id: "Wo5dMEP_BbI10",
    thumbNail: bean2,
    title: "Don't be shy!Mr bean",
    videoSpan: "50:10",
    subtitle: "cartoon world",
    views: "1M",
    publishedYear: "1 year ago",
    categoryName: "Animation",
    videoLink: "CjMt_tRsdo0",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    creator: "unknown"
  },
  {
    _id: "Wo5dMEP_BbI11",
    thumbNail: minion2,
    title: "Minions(2015)",
    videoSpan: "05:40",
    subtitle: "Animated movie",
    views: "1.2M",
    publishedYear: "4years ago",
    categoryName: "Animation",
    videoLink: "U71hsRLnfpA",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    creator: "unknown"
  },
  {
    _id: "Wo5dMEP_BbI12",
    thumbNail: tom,
    title: "Tom and Jerry",
    videoSpan: "10:20",
    subtitle: "Mouse Trouble",
    views: "100M",
    publishedYear: "1 year ago",
    categoryName: "Animation",
    videoLink: "L5TkeshVRhg",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    creator: "unknown"
  },
  {
    _id: "Wo5dMEP_BbI13",
    thumbNail: orlando,
    title: "Despicable Me3",
    videoSpan: "06:10",
    subtitle: "smart movie",
    views: "81k",
    publishedYear: "2 years ago",
    categoryName: "Animation",
    videoLink: "gqyai4u-JF8",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    creator: "unknown"
  },
  {
    _id: "Wo5dMEP_BbI14",
    thumbNail: whoRU,
    title: "Who are you",
    videoSpan: "05:30",
    subtitle: "A new short film",
    views: "11M",
    publishedYear: "1 year ago",
    categoryName: "Short film",
    videoLink: "GWGbOjlJDkU",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    creator: "unknown 60PbNFY2NHw"
  },
  {
    _id: "Wo5dMEP_BbI15",
    thumbNail: shtFilm1,
    title: "Get up get Done",
    videoSpan: "04:30",
    subtitle: "Motivate",
    views: "12M",
    publishedYear: "1 year ago",
    categoryName: "Motivational",
    videoLink: "60PbNFY2NHw",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    creator: "unknown"
  },
  {
    _id: "Wo5dMEP_BbI16",
    thumbNail: shtFilm,
    title: "No Excuses",
    videoSpan: "03:30",
    subtitle: "motivate self",
    views: "322k",
    publishedYear: "2 year ago",
    categoryName: "Motivational",
    videoLink: "wnHW6o8WMas",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    creator: "unknown"
  },
  {
    _id: "Wo5dMEP_BbI17",
    thumbNail: motive2,
    title: "Silent cild",
    videoSpan: "20:30",
    subtitle: "Illumination",
    views: "322k",
    publishedYear: "2 year ago",
    categoryName: "Short film",
    videoLink: "2GbxFIVQv8c",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    creator: "unknown"
  },
  {
    _id: "Wo5dMEP_BbI18",
    thumbNail: motive1,
    title: "The English Teacher",
    videoSpan: "20:04",
    subtitle: "Illumination",
    views: "422k",
    publishedYear: "1 year ago",
    categoryName: "Short film",
    videoLink: "2GbxFIVQv8c",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    creator: "unknown"
  }
];
